import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import HotTicker from "@/components/feature/HotTicker";
import Seo from "@/components/feature/Seo";
import Hero from "@/pages/home/components/Hero";
import CommentHighlights from "@/pages/home/components/CommentHighlights";
import Method from "@/pages/home/components/Method";
import CategoryBrowse from "@/pages/home/components/CategoryBrowse";
import Faq from "@/pages/home/components/Faq";
import { guFaqs } from "@/mocks/faqs";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace("#", "");
    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 60);
    return () => window.clearTimeout(timer);
  }, [location.hash]);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "瓜田观察",
      url: "https://2ndhair.com.cn/",
      description:
        "聚合网红吃瓜事件的评论区风向、网友热议与神评翻车现场，帮吃瓜群众快速看懂路人评价。",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://2ndhair.com.cn/topics?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: guFaqs.map((faq) => ({
        "@type": "Question",
        name: faq.question,
        acceptedAnswer: { "@type": "Answer", text: faq.answer },
      })),
    },
  ];

  return (
    <Layout>
      <Seo
        title="瓜田观察 - 网红吃瓜评论区风向与网友热议聚合"
        description="瓜田观察聚合全网网红吃瓜事件的评论区风向，收录网友热议、神评翻车与评论区沦陷现场，帮吃瓜群众快速看懂路人怎么评价这场瓜。"
        keywords="网红吃瓜,评论区,网友评论,吃瓜群众,网友热议"
        path="/"
        jsonLd={jsonLd}
      />
      <HotTicker />
      <Hero />
      <CommentHighlights />
      <Method />
      <CategoryBrowse />
      <Faq />
    </Layout>
  );
}